import React, { useState ,Suspense} from 'react';
import Navbar from './components/Navbar';
import './App.css';
import Sidebar from './components/Sidebar';
import { Routes, Route, useLocation } from 'react-router-dom';


import LoaderComponent from './layouts/LoaderComponent';
import Modal from '@mui/joy/Modal';
import { toggleTheme } from '../src/features/themeSlice';

import { Toggle } from 'rsuite';
import { useDispatch, useSelector } from 'react-redux'; 
import ProtectedRoute from './components/ProtectedRoute';         
import { Fab } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

// const DashboardServices = React.lazy(() => import('./layouts/DashboardServices'));
const DashboardMain = React.lazy(() => import('./layouts/DashboardMain'));


// Lazy-loaded components
const LandingPage = React.lazy(() => import('./layouts/LandingPage'));
const Pricing = React.lazy(() => import('./layouts/Pricing'));
const AboutUs = React.lazy(() => import('./layouts/AboutUs'));
const ContactUs = React.lazy(() => import('./layouts/ContactUs'));
const HowItWorks = React.lazy(() => import('./layouts/HowItWorks'));
const Dashboard = React.lazy(() => import('./components/Dashboard'));

// SuperAdmin Pages
const SuperAdminDashboard = React.lazy(() => import('./components/SuperAdminDashboard'));
const SuperAdminHome = React.lazy(() => import('./layouts/SuperAdminHome'));
const Permissions = React.lazy(() => import('./layouts/Permissions'));
const AllUsers = React.lazy(() => import('./layouts/AllUsers'));
const WorkspacesSuperAdmin = React.lazy(() => import('./layouts/WorkspacesSuperAdmin'));
const SystemSettings = React.lazy(() => import('./layouts/SystemSettings'));
const SuperAdminAllSites = React.lazy(() => import('./layouts/SuperAdminAllSites'));
const SuperAdminAllBuildings = React.lazy(() => import('./layouts/SuperAdminAllBuildings'));
const SuperAdminAllComponents = React.lazy(() => import('./layouts/SuperAdminAllComponents'));
const SuperAdminAllIncidents = React.lazy(() => import('./layouts/SuperAdminAllIncidents'));
const SuperAdminAllReports = React.lazy(() => import('./layouts/SuperAdminAllReports'));

// Other Roles Pages
const OtherRolesWorkspaces = React.lazy(() => import('./layouts/OtherRolesWorkspaces'));
const OtherRolesSites = React.lazy(() => import('./layouts/OtherRolesSites'));
const OtherRolesBuildings = React.lazy(() => import('./layouts/OtherRolesBuildings'));
const OtherRolesComponents = React.lazy(() => import('./layouts/OtherRolesComponents'));

// Task and Maintenance Pages
const AssignTasks = React.lazy(() => import('./layouts/AssignTasks'));
const Analytics = React.lazy(() => import('./layouts/Analytics'));
const MaintenanceTasks = React.lazy(() => import('./layouts/MaintenanceTasks'));
const AllMaintenanceTasks = React.lazy(() => import('./layouts/AllMaintenanceTasks'));
const MaintenancePlanning = React.lazy(() => import('./components/MaintenancePlanning'));

// Audit and Compliance Pages
const Audits = React.lazy(() => import('./layouts/Audits'));
const Deviations = React.lazy(() => import('./layouts/Deviations'));
const AllAudits = React.lazy(() => import('./layouts/AllAudits'));
const CorrectiveActions = React.lazy(() => import('./layouts/CorrectiveActions'));

// Investment and Financial Pages
const InvestmentDashboard = React.lazy(() => import('./layouts/InvestmentDashboard'));
const InvestmentTracking = React.lazy(() => import('./layouts/InvestmentTracking'));
const FinancialReportsDashboard = React.lazy(() => import('./layouts/FinancialReportsDashboard'));

// Project Management Pages
const ProjectPhases = React.lazy(() => import('./layouts/ProjectPhases'));
const CalendarView = React.lazy(() => import('./layouts/CalendarView'));
const MilestonesTable = React.lazy(() => import('./layouts/MilestonesTable'));

// Additional Pages
const Profile = React.lazy(() => import('./layouts/Profile'));
const ActionsTracking = React.lazy(() => import('./layouts/ActionsTracking'));
const ReservationList = React.lazy(() => import('./layouts/ReservationList'));
const AssignCorrection = React.lazy(() => import('./layouts/AssignCorrection'));
const DeliveryDashboard = React.lazy(() => import('./layouts/DeliveryDashboard'));


function ModeSwitcher({theme,dispatch}) {
  const [mounted, setMounted] = React.useState(false);
  

  React.useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }
  return (
    <Toggle 
      style={{
        position: 'fixed',
          right: '5px',
          top: '60px',
          zIndex:100000,
          color:'white',
          fontSize:'bold',
          background:'#088fa6',
          border:'1px solid rgb(21, 255, 169)',
          borderRadius:'20px',
          '&:hover':{
              background: '#088fa6',
              boxShadow:'0 0 6px rgb(21, 255, 169)'
          },
          padding:'3px'
      }}
      
      color="rgb(21, 255, 169)" 
      onChange={() =>
        dispatch(toggleTheme())
      }
    >
      <strong>
        {theme==='dark'?'Dark Mode':'Light Mode'}
      </strong>
    </Toggle>
  );
}



function App() {
  
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(true);
  const location=useLocation();
  const user=localStorage.getItem('user');
  const token=localStorage.getItem('token');
  const dispatch = useDispatch();
  const theme = useSelector((state) => state.theme.theme);
  const backgroundColor = theme === 'dark' ? '#1c1c1c' : '#fffdfd';

  const showSidebar = !['/', '/Pricing', '/AboutUs', '/ContactUs', '/HowItWorks'].includes(location.pathname);

  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Smooth scrolling animation
    });
  };

  return (
    <div className={`App ${isSidebarExpanded ? 'sidebar-expanded' : 'sidebar-collapsed'}`}>
        <Navbar />
        <div className="body_container">
          {showSidebar && (
            <div className="sidebar_container">
              <Sidebar theme={theme} background={backgroundColor} onToggle={() => setIsSidebarExpanded(!isSidebarExpanded)} />
            </div>
          )}
          {
            token&&(
              <Fab 
                color="primary" 
                aria-label="scroll to top" 
                onClick={handleClick}
                sx={{ position: 'fixed', bottom: 16, right: 16 ,background:'#088fa6',
                  border:'1px solid rgb(21, 255, 169)',
                  borderRadius:'50px',
                  '&:hover':{
                      background: '#088fa6',
                      boxShadow:'0 0 6px rgb(21, 255, 169)'
                  }}} 
              >
                <ArrowUpwardIcon />
              </Fab>
            )
          }
          <ModeSwitcher  theme={theme} dispatch={dispatch}/>
          <div
            className="routes_container"
            style={{
              background:backgroundColor,
              transition:'0.3s',
              marginLeft: showSidebar ? '' : 0,
              width:location.pathname==='/'?'100%':'100%',overflowX:'scroll'}}
          > 
            <Suspense fallback={<LoaderComponent/>}>
              <Routes>
                <Route path="/" element={<LandingPage/>} />
                <Route path="/Pricing" element={<Pricing/>} />
                <Route path="/AboutUs" element={<AboutUs/>} />
                <Route path="/ContactUs" element={<ContactUs/>} />
                <Route path="/HowItWorks" element={<HowItWorks/>} />
                <Route path="/dashboard/home/dashboard" element={<ProtectedRoute><SuperAdminDashboard><SuperAdminHome /></SuperAdminDashboard></ProtectedRoute>} />
                <Route path="/dashboard/SuperAdmin/Permissions" element={<ProtectedRoute><SuperAdminDashboard><Permissions /></SuperAdminDashboard></ProtectedRoute>} />
                <Route path="/dashboard/SuperAdmin/Workspaces" element={<ProtectedRoute><SuperAdminDashboard><WorkspacesSuperAdmin/></SuperAdminDashboard></ProtectedRoute>} />
                <Route path="/dashboard/SuperAdmin/Sites" element={<ProtectedRoute><SuperAdminDashboard><SuperAdminAllSites /></SuperAdminDashboard></ProtectedRoute>} />
                <Route path="/dashboard/SuperAdmin/Buildings" element={<ProtectedRoute><SuperAdminDashboard><SuperAdminAllBuildings /></SuperAdminDashboard></ProtectedRoute>} />
                <Route path="/dashboard/SuperAdmin/Components" element={<ProtectedRoute><SuperAdminDashboard><SuperAdminAllComponents /></SuperAdminDashboard></ProtectedRoute>} />
                <Route path="/dashboard/SuperAdmin/Incidents" element={<ProtectedRoute><SuperAdminDashboard><SuperAdminAllIncidents /></SuperAdminDashboard></ProtectedRoute>} />
                <Route path="/dashboard/SuperAdmin/Reports" element={<ProtectedRoute><SuperAdminDashboard><SuperAdminAllReports /></SuperAdminDashboard></ProtectedRoute>} />
                <Route path="/dashboard/SuperAdmin/AllUsers" element={<ProtectedRoute><SuperAdminDashboard><AllUsers /></SuperAdminDashboard></ProtectedRoute>} />
                <Route path="/dashboard/SuperAdmin/Settings" element={<ProtectedRoute><SuperAdminDashboard><SystemSettings /></SuperAdminDashboard></ProtectedRoute>} />
                <Route path="/dashboard/SuperAdmin/assignTasks" element={<ProtectedRoute><SuperAdminDashboard><AssignTasks /></SuperAdminDashboard></ProtectedRoute>} />
                <Route path="/dashboard/SuperAdmin/maintenanceTasks" element={<ProtectedRoute><SuperAdminDashboard><MaintenanceTasks /></SuperAdminDashboard></ProtectedRoute>} />
                <Route path="/dashboard/SuperAdmin/AllMaintenanceTasks" element={<ProtectedRoute><SuperAdminDashboard><AllMaintenanceTasks /></SuperAdminDashboard></ProtectedRoute>} />
                <Route path="/dashboard/SuperAdmin/Analytics" element={<ProtectedRoute><SuperAdminDashboard><Analytics /></SuperAdminDashboard></ProtectedRoute>} />
                <Route path="/dashboard/Add_Audits" element={<ProtectedRoute><SuperAdminDashboard><Audits /></SuperAdminDashboard></ProtectedRoute>} />
                <Route path="/dashboard/Audits" element={<ProtectedRoute><SuperAdminDashboard><AllAudits /></SuperAdminDashboard></ProtectedRoute>} />
                <Route path="/dashboard/Deviations" element={<ProtectedRoute><SuperAdminDashboard><Deviations /></SuperAdminDashboard></ProtectedRoute>} />
                <Route path="/dashboard/Corrective_actions" element={<ProtectedRoute><SuperAdminDashboard><CorrectiveActions /></SuperAdminDashboard></ProtectedRoute>} />
                <Route path="/dashboard/SuperAdmin/MaintenancePlanning" element={<ProtectedRoute><SuperAdminDashboard><MaintenancePlanning /></SuperAdminDashboard></ProtectedRoute>} />
                <Route path={`/dashboard/Workspaces`} element={<ProtectedRoute><Dashboard><OtherRolesWorkspaces /></Dashboard></ProtectedRoute>} />
                <Route path={`/dashboard/Sites`} element={<ProtectedRoute><Dashboard><OtherRolesSites /></Dashboard></ProtectedRoute>} /> 
                <Route path={`/dashboard/Buildings`} element={<ProtectedRoute><Dashboard><OtherRolesBuildings /></Dashboard></ProtectedRoute>} />
                <Route path={`/dashboard/Components`} element={<ProtectedRoute><Dashboard><OtherRolesComponents /></Dashboard></ProtectedRoute>} />
                <Route path={`/dashboard/Profile`} element={<ProtectedRoute><Dashboard><Profile /></Dashboard></ProtectedRoute>} />
                {/* <Route path={`/dashboard/home/DashboardServices`} element={<ProtectedRoute><Dashboard><DashboardServices /></Dashboard></ProtectedRoute>} /> */}
                <Route path={`/dashboard/home/DashboardServicesMain`} element={<ProtectedRoute><Dashboard><DashboardMain /></Dashboard></ProtectedRoute>} />
                <Route path={`/dashboard/home/investment_dashboard`} element={<ProtectedRoute><Dashboard><InvestmentDashboard /></Dashboard></ProtectedRoute>} />
                <Route path={`/dashboard/home/investments_tracking`} element={<ProtectedRoute><Dashboard><InvestmentTracking /></Dashboard></ProtectedRoute>} />
                <Route path={`/dashboard/home/financial_reports_dashboard`} element={<ProtectedRoute><Dashboard><FinancialReportsDashboard /></Dashboard></ProtectedRoute>} />
                <Route path={`/dashboard/home/construction_phases`} element={<ProtectedRoute><Dashboard><ProjectPhases /></Dashboard></ProtectedRoute>} />
                <Route path={`/dashboard/home/calender_projects_construction`} element={<ProtectedRoute><Dashboard><CalendarView /></Dashboard></ProtectedRoute>} />
                <Route path={`/dashboard/home/milestones`} element={<ProtectedRoute><Dashboard><MilestonesTable /></Dashboard></ProtectedRoute>} />
                <Route path={`/dashboard/home/reservations`} element={<ProtectedRoute><Dashboard><ReservationList /></Dashboard></ProtectedRoute>} />
                <Route path={`/dashboard/home/corrections`} element={<ProtectedRoute><Dashboard><AssignCorrection /></Dashboard></ProtectedRoute>} />
                <Route path={`/dashboard/home/actions`} element={<ProtectedRoute><Dashboard><ActionsTracking /></Dashboard></ProtectedRoute>} />
                <Route path={`/dashboard/home/deliveries`} element={<ProtectedRoute><Dashboard><DeliveryDashboard /></Dashboard></ProtectedRoute>} />
              </Routes>
            </Suspense>
          </div>
        </div>
      </div>
  ); 
}

export default App;
